import { toast as toastMessage } from "react-toastify";
import swal from "sweetalert";

function toastError(
    mensaje,
    posicion = "bottom-right",
    ocultarNotificacionAnterior = true
) {
    ocultarNotificacionAnterior && toastMessage.dismiss();
    toastMessage(mensaje, {
        type: "error",
        position: posicion,
    });
}

function toastSuccess(
    mensaje,
    posicion = "bottom-right",
    ocultarNotificacionAnterior = true
) {
    ocultarNotificacionAnterior && toastMessage.dismiss();
    toastMessage(mensaje, {
        type: "success",
        position: posicion,
    });
}

function toastInfo(
    mensaje,
    posicion = "bottom-right",
    ocultarNotificacionAnterior = true
) {
    ocultarNotificacionAnterior && toastMessage.dismiss();
    toastMessage(mensaje, {
        type: "info",
        position: posicion,
    });
}

function toastWarning(
    mensaje,
    posicion = "bottom-right",
    ocultarNotificacionAnterior = true
) {
    ocultarNotificacionAnterior && toastMessage.dismiss();
    toastMessage(mensaje, {
        type: "warning",
        position: posicion,
    });
}

const swalInfo = (message) => swal(message, "", "info");
const swalConfirm = async (
    message,
    textoAceptar = "Aceptar",
    textoCancelar = "Cancelar"
) => {
    const valor = await swal({
        title: "Confirmación",
        text: message,
        icon: "info",
        buttons: {
            cancelar: {
                text: textoCancelar,
                className: "btn-danger",
            },
            aceptar: {
                text: textoAceptar,
                className: "btn-success",
            },
        },
    });

    return valor === "aceptar";
};

const swalError = (message) => swal(message, "", "danger");
const swalSuccess = (message) => swal(message, "", "success");
const swalWarning = (message) => swal(message, "", "warning");

export const toast = {
    info: toastInfo,
    error: toastError,
    success: toastSuccess,
    warning: toastWarning,
};

export const sweetAl = {
    info: swalInfo,
    error: swalError,
    success: swalSuccess,
    warning: swalWarning,
    confirm: swalConfirm,
};
